import React, { createContext, useContext, useEffect, useState } from "react";
import { translations } from "./translations";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "id";
    return localStorage.getItem("batik_lang") || "id";
  });

  useEffect(() => {
    localStorage.setItem("batik_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = (key) => {
    const segs = key.split(".");
    let node = translations[lang];
    for (const s of segs) {
      if (node && typeof node === "object" && s in node) node = node[s];
      else return key;
    }
    return node;
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
}
